/* import __COLOCATED_TEMPLATE__ from './item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface BvFormLayoutItemSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvFormLayoutItemComponent = templateOnlyComponent<BvFormLayoutItemSignature>();

export default BvFormLayoutItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvFormLayout::Item': typeof BvFormLayoutItemComponent;
    'bv-form-layout/item': typeof BvFormLayoutItemComponent;
  }
}
